module.exports = __webpack_public_path__ + "static/media/homebackground.7435c1bd.jpg";